<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active">CONCENTRADORES</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-concentrador></menu-concentrador>
                    </div>
                    <div class="col-md-9">

                        <div class="col-md-7">
                            <label class="control-label">BUSCA POR NOME DO CONCENTRADOR</label>
                            <input type="text" v-model="nome" class="form-control" >
                        </div>

                        <div class="col-md-5">
                            <br/>
                            <blockquote class="blockquote-reverse">
                                Total de Concentradores: <b>{{getContratos.length}}</b>
                            </blockquote>
                        </div>

                        <div class="col-md-12" style="margin-top: 20px">



                            <table id="mytable" class="table table-bordred table-striped">

                                <thead>
                                    <tr>
                                        <th>CONCENTRADOR</th>
                                        <th style="text-align: center;">INTERFACE</th>
                                        <th style="text-align: center;width: 140px">AÇÕES</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr v-for="r in getContratos" v-bind:key="r._id">
                                        <td>{{r.nome}}</td>
                                        <td style="text-align: center;">{{r.interface}}</td>
                                        <td style="text-align: center">
                                            <a :href="'#/concentrador/' + r._id" class="btn btn-primary btn-xs">
                                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                            </a> &nbsp;
                                            <button @click="excluir(r._id)" v-if="user.level < 3" class="btn btn-danger btn-xs">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuConcentrador from "../../menus/concentrador.vue";
import { Concentrador } from "../../class/index";
/*global swal*/
export default {
    components: {
        MenuConcentrador
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                return player.cliente.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    methods: {
        excluir(id) {
            swal.queue([
                {
                    title: "EXCLUIR",
                    confirmButtonText: "Excluir",
                    text: "Posso excluir o concentrador?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Concentrador.excluir(id)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.error(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        load() {
            Concentrador.all()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    }
};
</script>
